import { Fragment, ReactNode, useState } from 'react'
import { Transition, Dialog } from '@headlessui/react'
import { InformationIcon, InfoIcon, CrossIcon } from '@sbab-ui/icons'
import { Base } from '@sbab-ui/components'

interface Props {
  children?: ReactNode
  title: string
  showTitle?: boolean
}

export default function SlideOver({ children, title, showTitle = false }: Readonly<Props>) {
  const [showSlideOver, setShowSlideOver] = useState(false)

  function handleSlideOverClick() {
    setShowSlideOver(!showSlideOver)
  }

  return (
    <>
      {showTitle ? (
        <button
          className="box-content flex min-h-[26px] 
       self-start pb-px hover:border-b hover:pb-0 focus:outline-none focus:ring focus:ring-focus_blue"
          onClick={handleSlideOverClick}
          style={{ color: 'inherit' }}
        >
          <InformationIcon className="mr-2 rotate-180" aria-label="Information Ikon"/>
          <Base className="!mt-0">{title}</Base>
        </button>
      ) : (
        <button
          className="mr-2 box-content flex 
         size-6 w-auto pb-px hover:border-b hover:pb-0 focus:outline-none focus:ring focus:ring-focus_blue"
          onClick={handleSlideOverClick}
          style={{ color: 'inherit' }}
        >
          <InformationIcon className="rotate-180" aria-label="Information Ikon" />
        </button>
      )}

      <Transition.Root show={showSlideOver} as={Fragment}>
        <Dialog as="div" className="disable-sv-tw relative z-20" onClose={handleSlideOverClick}>
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-scale-500"
            enterFrom="opacity-scale-0"
            enterTo="opacity-scale-100"
            leave="ease-in-out duration-scale-500"
            leaveFrom="opacity-scale-100"
            leaveTo="opacity-scale-0"
          >
            <div className="fixed inset-0 bg-neutral-50/75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500"
                  enterFrom="max-sm:translate-y-full sm:translate-x-full"
                  enterTo="max-sm:translate-y-0 sm:translate-x-0"
                  leave="transform transition ease-in-out duration-300"
                  leaveFrom="max-sm:translate-y-0 sm:translate-x-0"
                  leaveTo="max-sm:translate-y-full sm:translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto w-screen sm:max-w-md">
                    <div className="flex h-full flex-col overflow-y-auto bg-white pb-[59px] shadow-xl min-[641px]:pb-[104px]">
                      <div className="flex h-[72px] min-h-[72px] items-center justify-between px-4 sm:px-6">
                        <div className="flex">
                          <InfoIcon className="text-orange" aria-label="Information Ikon" />
                          {showTitle}
                          <Dialog.Title className=" text-lg font-medium leading-[26px] text-black">
                            {title}
                          </Dialog.Title>
                        </div>
                        <div className="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            className="flex size-10 items-center justify-center rounded-md 
                          hover:text-neutral-50  focus:outline-none focus:ring-2 focus:ring-focus_blue focus:ring-offset-2"
                            onClick={handleSlideOverClick}
                          >
                            <span className="sr-only">Stäng</span>
                            <CrossIcon />
                          </button>
                        </div>
                      </div>
                      <hr className="h-px text-neutral-80" />
                      <div className="relative mt-6 flex-1 px-4 sm:px-6">{children}</div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  )
}
